import React from 'react'
import { Observable } from 'rx'
import {
  ConfirmBetSucceeded,
  ConfirmBetslipBetsSucceeded,
  ConfirmMultiBetSucceeded,
} from '@core/Areas/Quickbet/signals'
import { queryClient } from '@core/Data/ReactQuery'
import { queryKeys } from '@core/Data/ReactQuery/constants'

/** Used primarily for ReBet, as Quickbet and BetSlip can be opened over account activity */
export const useRefreshOnBetPlaced = () => {
  React.useEffect(() => {
    const clearAccountActivityCache = () =>
      queryClient.invalidateQueries({
        queryKey: [queryKeys.accountBase, queryKeys.accountActivityBase],
      })

    const subscription = Observable.merge(
      ConfirmBetSucceeded.signal$,
      ConfirmBetslipBetsSucceeded.signal$,
      ConfirmMultiBetSucceeded.signal$
    )
      .debounce(300)
      .subscribe(clearAccountActivityCache)

    return () => subscription.dispose()
  }, [])
}
